import { useMutation } from "@pinia/colada";
import type { AjaxParams } from "@/utils/ajax-request";
import type { StatusIcons } from "@/utils/status-icon";

export type MutationHandler<TResult> = {
  action: string;
  icons?: StatusIcons;
  resetDelay?: number;
  onSuccess?: (result: TResult) => void;
  onError?: () => void;
};

export function useMutationHandler<TResult, TInput extends AjaxParams>({ action, icons, resetDelay, onSuccess, onError }: MutationHandler<TResult>) {
  const { mutate, reset, status, isLoading } = useMutation({
    mutation: (params: TInput) => ajaxRequest<TResult>(action, params),
    onSuccess: (result: TResult) => onSuccess && onSuccess(result),
    onError: () => onError && onError(),
    onSettled: () => {
      if (resetDelay) setTimeout(() => reset(), resetDelay);
      else reset();
    },
  });
  const isDisabled = computed(() => isLoading.value || status.value !== "pending");
  const icon = getStatusIcon(icons || {}, isLoading, status);
  return { mutate, isLoading, isDisabled, icon };
}
